import z from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/v2/tasks").GET();

export type GetTasksV2Query = z.infer<typeof endpoint.q>;
export type GetTasksV2Response = z.infer<typeof endpoint.res>;
export type TaskV2 = NonNullable<GetTasksV2Response["tasks"]>[number];
export type TaskV2Shift = NonNullable<TaskV2["shifts"]>[number];
export type TaskV2User = TaskV2["manager"];
export type TaskV2Organisation = TaskV2["organisation"];
export type TaskV2Location = TaskV2["location"];
export type TaskV2Department = TaskV2["department"];
export type TaskV2SelectionStatus = TaskV2["selectionStatus"];
export type TaskV2SelectionTarget = TaskV2["selectionTarget"];

export async function getTasksV2({
    query,
    signal,
}: {
    query: GetTasksV2Query;
    signal?: AbortSignal;
}): Promise<GetTasksV2Response> {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));
    const res = await call({ query, signal });

    return res;
}
